var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.tagList),function(tag,idx){return _c('tag',{key:idx,staticClass:"tag",attrs:{"value":tag,"color":_vm.getColor(tag)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }